import { render, staticRenderFns } from "./RegionsDropdownSelect.vue?vue&type=template&id=04c64265&scoped=true&"
import script from "./RegionsDropdownSelect.vue?vue&type=script&lang=js&"
export * from "./RegionsDropdownSelect.vue?vue&type=script&lang=js&"
import style0 from "./RegionsDropdownSelect.vue?vue&type=style&index=0&id=04c64265&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c64265",
  null
  
)

export default component.exports